<template>
	<div class="logistic">
		<Navbar />
	</div>
</template>

<script>
import Navbar from '@/components/logistic/Navbar';

export default {
	components: {
		Navbar
	},
	created() {
	}

};

</script>